const ContactDocument = `
  id
  meta
  updatedAt
`;

export default ContactDocument;
